<template>
  <div class="feature">
    <div class="feature-level" v-for="(level, index) in feature.levels" :key="index">
      <header class="feature-level__header">
        <h4 class="feaure-level__heading">
          <span class="feature-level__name">{{ levelName( level, index ) }}</span>
          <span class="feature-level__cost" v-if="level.cost > 0">
          - {{ this.formatCost( level.cost ) }}
        </span>
        </h4>

      </header>

      <div class="selections-wrapper">
        <div class="level-selections">
          <div class="level-selection" v-for="(selection, selectionIndex) in level.selections" :key="selectionIndex" :class="[{selected: this.chosen === selection }]">
            <label v-bind:for="'selection-' + feature.ID + '-' + selection">

              <selection-sample :selections="selections" :selectedID="selection"/>
              <input type="radio"
                     v-bind:id="'selection-' + feature.ID + '-' + selection"
                     v-bind:value="selection"
                     v-model="chosen"
                     @click="handleRadioClick(selection)"
              >
            </label>
          </div>

        </div>
      </div>


    </div>
  </div>
</template>
<script>
import SelectionSample from "@/components/SelectionSample";

export default {
  components: { SelectionSample },
  props: [ 'feature', 'selections', 'currentChosen'],
  data() {
    return {
      chosen: this.currentChosen
    };
  },
  methods: {
    levelName( level, index ) {
      if ( level.label ) {
        return level.label;
      } else if ( index === 0 ) {
        return 'Standard';
      } else {
        return 'Premium';
      }
    },
    formatCost( number ) {
      return '$' + number;
    },
    handleRadioClick( selection ) {
      // If the clicked radio button is already selected, unset the chosen data property.
      if ( selection === this.chosen ) {
        this.chosen = null; // or any other default value that you prefer.
      }
    }
  },
  watch: {
    chosen: {
      handler( val ) {
        this.$emit( 'chosenSelection', val );
      },
      deep: true,
    }
  },
  emits: [ 'chosenSelection' ]

};
</script>

<style lang="scss">
@import 'src/scss/accordion.scss';
@import 'src/scss/feature.scss';
</style>
